module.exports = __webpack_public_path__ + "static/media/logo-no-bg.2820273d.png";